export function formatExamples(examples = []) {
  if (!Array.isArray(examples) || !examples.length) return "[]";
  const rendered = examples
    .slice(0, 5)
    .map((v) => (typeof v === "string" ? `'${v}'` : String(v)))
    .join(", ");
  return `[ ${rendered}${examples.length > 5 ? ", …" : ""} ]`;
}